import { render, staticRenderFns } from "./Budget.vue?vue&type=template&id=2c7e8b2b&scoped=true&"
import script from "./Budget.vue?vue&type=script&lang=js&"
export * from "./Budget.vue?vue&type=script&lang=js&"
import style0 from "./Budget.vue?vue&type=style&index=0&id=2c7e8b2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7e8b2b",
  null
  
)

export default component.exports